module.exports = __webpack_public_path__ + "static/media/icon-warning.d378fd8c.svg";